import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectCheckboxDocument',
    standalone: false
})
export class SelectCheckboxDocumentPipe implements PipeTransform {

  transform(selectedDocuments: number[], selectedDocumentId: number): boolean {
    if (selectedDocuments) {
      return selectedDocuments.includes(selectedDocumentId);
    }
  }

}
